import { writable } from 'svelte/store'

export type Hints = Record<string, boolean>

// eg price: human readable hint
const store = writable({} as Hints)

export { store as hints }
